import type { UnionTypeLibelle } from '../../../techniques'

export const NatureContrat = ['Cdd', 'Cdi'] as const

export type NatureContrat = (typeof NatureContrat)[number]

export const NatureContratLibelle: UnionTypeLibelle<NatureContrat> = {
  Cdd: 'CDD',
  Cdi: 'CDI',
} as const
